var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodexLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0428\\u0430\\u0440_1",
    "data-name": "\\u0428\\u0430\\u0440 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 417 473",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e02737;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mknnZN"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8,0l161.05,165.44c1.5,2.08,1.48,5.06,0,7.11-52.12,52.52-102.41,106.93-155.08,158.92-4.65,4.59-6.34,10.54-13.97,3.53v-5l155.93-160.63L0,8V0h8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54,0l158.96,169.51L51.5,338.1c-4.19-.02-7.3-5.13-4.55-8.66l142.56-149.43,9.41-11.38L51.49,14.01c-3.86-5.3-8.79-7.99-2.49-14.01h5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99,0l157.99,169.43-159.49,168.67c-5.44.37-8.45-5.65-4.49-9.6l145.51-153.49,4.42-6.38L93.01,9.5c-3.5-3.74-1.68-6.95,1.99-9.5h4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M201,473c-29.72-7.48-40.97-43.42-26.52-69.02,11.96-21.19,38.03-27.49,57.53-12.5l6.99,7.51v-51h10v87.5c0,10.69-11.16,27.18-20.7,32.3l-13.3,5.2h-14ZM202.74,394.24c-34.61,5.41-31.88,70.45,7.72,68.77,40.02-1.7,37.87-75.9-7.72-68.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292,473c-26.94-7.93-38.45-32.56-31.71-59.21,3.5-13.86,15.5-27.77,30.29-29.71,31.29-4.1,49.13,18.23,47.42,47.92h-69c2.73,22.74,21.69,36.12,43.97,28.47,4.78-1.64,12.22-9.43,16.55-5.49,8.74,7.94-17.67,17-22.52,18.02h-15ZM327,422c-2.13-37.59-54.39-37.02-57,0h57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125,473h-15c-55.9-12.32-40.11-101.41,17.25-88.75,41.23,9.1,44.82,72.33,5.04,86.53l-7.29,2.22ZM111.76,394.26c-37.25,5.44-33.93,70.89,7.71,68.73,43.01-2.23,39.6-75.64-7.71-68.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M409,0h8v8l-138.94,145.56c-6.07,4.62-13.56-2.06-8.06-8.06L409,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M417,330v5c-2.65,2.21-5.05,4.59-8.56,2.05-41.51-44.08-84.74-86.7-125.96-131.03-2.58-2.78-14.42-15.19-14.42-17.51,0-1.76,1.93-4.83,3.64-5.34,6.01-1.79,8.14,4.24,11.27,7.37,45.62,45.54,88.57,93.77,134.03,139.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M417,385v1l-32.01,40.48,31.01,44.52h-14l-24.02-36c-1.86-1.24-24.11,33.09-26.99,35.49l-13.99.5,32.87-43.68-29.87-42.3,13.99.49,23.5,32.47,24.93-32.05c3.56-2.15,10.34-.37,14.57-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374,0c3.67,2.55,5.49,5.76,1.99,9.5-36.18,37.48-72.6,74.72-109.02,111.97-3.17,3.24-10.99,14.46-15.47,14.46s-7.32-5.83-4.55-9.49L370,0h4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49,473h-16c-18.17-4.93-27.53-17.72-33-35v-19c5.36-25.11,27.23-42.63,53.27-32.77,5.53,2.09,22.9,14.52,15.7,20.24-5.32,4.23-8.51-3.37-12.5-6.45-13.7-10.55-33.47-7.32-41.66,8.29-13.9,26.52,5.24,65.45,38.17,52.17,3.99-1.61,12.46-10.64,15.51-4.49,4.37,8.81-13.86,14.18-19.5,17.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M335,0c2.52,3.26,4.4,5.98.99,9.5l-102.93,105.06c-5.9,4.87-13.28-2.45-8.05-8.06L330,0h5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.73,202.16c4.9-.76,10.25,8.3,13.25,11.37,37.27,38.07,74.34,76.32,111.54,114.45,5.65,5.31-.32,12.98-7.07,9.07l-121.49-125.49c-2.5-3.5-.63-8.72,3.78-9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.7,222.19c1.9-.59,4.27-.47,5.86.77l102.96,105.03c6.28,6.62-2.11,14.01-8.54,7.54l-103.58-106.5c-1.01-2.2,1.05-6.14,3.3-6.84Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodexLogo);
export default __webpack_public_path__ + "static/media/codex_logo.47334b26f20ba695044912d7fa3536d2.svg";
export { ForwardRef as ReactComponent };